namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmVlastnost extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmVlastnostReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmVlastnostObj & GContent;
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;
        returnValue: boolean;
        openModal: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmVlastnostObj());
            this.detailObj.createBase({
                contentName: "detailAdmVlastnost",
                contentCaption: "jres:29932128",
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            this.detailObj.returnValue = this.returnValue;
            this.detailObj.openModal = this.openModal;
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                if (this.data.typ_vla == 20)
                    tabs.push(this.detailObj.createHodnotaVlastnostSubTask())
                tabs.push(this.detailObj.createNadrizeneSubTask());
                tabs.push(this.detailObj.getAuditPristupuTab());
            }
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                if (this.data.typ_vla == 20)
                    groups.push(this.detailObj.createHodnotaVlastnostGroup())
                groups.push(this.detailObj.createNadrizeneGroup());
                groups.push(this.detailObj.getAuditPristupuGroup());
            }
            builder.withComponent<this>("DetailAdmVlastnost", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
            var rowMaska = this.findFormRows("row_maska");
            rowMaska.gformrow("setLabel", "jres:33000549", "jres:33000550") //RC 33000550 : Do masky lze pou��t n�sleduj�c� z�stupky<br />#CIR - Maxim�ln� po�adov� ��slo<br />#ROK - Aktu�ln� rok<br />#POD - Zkratka spisov�ho uzlu<br />#FUN - zkratka funk�n�ho m�sta<br / >#REF - zkratka referenta<br />#ORJ - zkratka organiza�n� jednotky<br />#FUK - K�d funk�n�ho m�sta<br />#REK - K�d referenta<br />#ORK - K�d organiza�n� jednotky
            var rowPovinnost = this.findFormRows("row_priz_pov");
            rowPovinnost.gformrow("setLabel", "jres:29925144", "jres:33000604") //RC 33000604 : Vlastnost bude povinn�, pokud bude samostatn� p�id�na na dokument.
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmVlastnostObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmVlastnostReadDto> {
        private gridNadrizene: JQuery<HTMLElement>;
        returnValue: boolean;
        openModal: boolean;

        create() {
           
        }

        textPopis(): string | undefined | null {
            return "{0}".format((this.data.nazev) ? this.data["nazev"] : "")
        }

        setSxsDetail(): string {
            return "{0}".format((this.data.ixs_vla) ? this.data.ixs_vla : "");
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmVlastnostSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.AdmVlastnost.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderGinsvla")
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        returnValueFunction() {
            if (this.data) {
                if (this.data.ixs_vla)
                    return { ixs_vla: this.data.ixs_vla };
            }
            return null;
        }

        reloadData(filterObj: any, dataObj: any) {
            filterObj.returnValue = this.returnValue;
            filterObj.openModal = this.openModal;
            if (this.openModal == true)
                $.content().dialogs.showModalWindow(["Gordic.Adm.WebControls.DetailAdmVlastnost", filterObj],
                    dataObj, {
                    height: 800,
                    width: 800
                });
            else 
               $.content().navigate(["Gordic.Adm.WebControls.DetailAdmVlastnost", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): JQueryPromise<Gordic.Data.View<Gordic.Data.UnpackRow<any>>> {
            return this.cnt.isl.AdmVlastnost.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.nazev) ? this.data.nazev : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            if (this.openModal == true) {
                return [
                    "actEdit*",
                    { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                    {
                        type: "static", caption: "jres:33000138", icon: "fa-link", favorite: true, children: [
                            { action: this.cnt.actions.actOpenDefaultValueVlastnost }
                        ]
                    },
                    { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                    { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
                ]
            } else {
                return [
                    "actEdit*",
                    { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                    "actCancelEdit*",
                    {
                        type: "static", caption: "jres:33000138", icon: "fa-link", favorite: true, children: [
                            { action: this.cnt.actions.actOpenDefaultValueVlastnost },
                            { action: this.cnt.actions.actOpenSeznamAdmVlastnostObjekt2 },
                            { action: this.cnt.actions.actOpenSeznamAdmVlastnostTypDokumentu },
                        ]
                    },
                    { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                    { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
                ]
            }
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenSeznamAdmVlastnostObjekt2: {
                    icon: "fa-link",
                    caption: "jres:33000415",
                    enabled: !this.options.newRecord,
                    run: () => {
                        this.openSeznamAdmVlastnostObjekt2()
                    }
                },
                actOpenSeznamAdmVlastnostTypDokumentu: {
                    icon: "fa-link",
                    caption: "jres:33000477", //RC 33000477 : Nav�zan� typy dokument�
                    tooltip: "jres:33000512", //RC 33000512 : Umo�n� p�i�adit vlastnost jako p�eddefinovan� k vybran�m typ�m dokument�
                    enabled: !this.options.newRecord,
                    run: () => {
                        this.openSeznamAdmVlastnostTypDokumentu()
                    }
                },
                actOpenDefaultValueVlastnost: {
                    icon: "fa-link",
                    caption: "jres:33000475", //RC 33000475 : Nastaven� defaultn� hodnoty
                    enabled: !this.options.newRecord && this.data.Permissions?.CanWrite.value == true,
                    run: () => {
                        this.openDefaultValueVlastnost();
                    }
                },
                actOpenDetailStrukturaProfil: {
                    icon: "gi-detail",
                    caption: "jres:33000564", //RC 33000564 : Detail p�i�azen� struktury a porfilu
                    run: () => {
                        this.openDetailStrukturaProfil();
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {
            this.cnt.actions.actOpenDefaultValueVlastnost?.update({ enabled: !this.options.newRecord && editMode == false && this.data.Permissions?.CanWrite.value == true })
        }

        createForm() {
            this.form.form.layoutDescriptor = "L2M1S1"
            this.MakeSection("")
            this.MakeField("ixs_vla");
            this.MakeField("nazev");
            this.MakeField("zkratka");
            this.MakeSelectField("priz_add", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_add=value.priz_an" });
            this.MakeSelectField("priz_edit", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_edit=value.priz_an" });
            this.MakeSelectField("typ_vla", Gordic.Prefabs.Select.ginctvp(), {
                model: "model.typ_vla=value.typ_vla",
                change: (ev, ctx) => {
                    this.HideField("ixs_cis");
                    this.HideField("velikost")
                    if (ctx.value) {
                        if (!Array.isArray(ctx.value)) {
                            if (ctx.value.typ_vla == 30)
                                this.ShowField("ixs_cis")
                            else 
                                this.ShowField("velikost")
                        } else
                            this.ShowField("velikost")
                    } else {
                        this.ShowField("velikost")
                    }
                }
            });
            this.MakeSelectField("dat_typ", Gordic.Prefabs.Select.gincdat(), { model: "model.dat_typ=value.dat_typ" });
            this.MakeField("velikost");
            this.MakeSelectField("ixs_cis", Gordic.Prefabs.Select.ginscis(), { model: "model.ixs_cis=value.ixs_cis" })
            this.MakeField("maska");
            this.MakeSection("")
            this.MakeField("kod", {
                flag: this.createFlagNemenne(),
                validators: [
                    new Gordic.Validators.Required({ stopping: true }),
                    new Gordic.Validators.Length({ min: 0, max: 6 }),
                    this.createValidatorKod()
                ]
            });
            this.MakeField("kod_form", {
                validators: [
                    this.createValidatorKodForm()
                ]
            });
            this.MakeSelectField("priz_del", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_del=value.priz_an" });
            this.MakeBoolField("priz_pov");
            //this.MakeFormField("barva", {
            //    form: Gordic.Adm.WebControls.BaseForms.ColorSelectForm(),
            //    dropdown: false,
            //    dialogOptions: { width: 630, height: 300 },
            //    change: function (ev, ctx) {
            //        if (ctx.value)
            //            $(this).gfield("setValue", { red: ctx.value.red, green: ctx.value.green, blue: ctx.value.blue, hexa: ctx.value.hexa })
            //        else
            //            $(this).gfield("setValue", null);
            //    },
            //    itemTemplate: (value) => { return Gordic.Adm.Utils.ItemTemplateColorBox(value) },
            //    modelValueTransform: {
            //        apply: (value) => {
            //            if (value) {
            //                var rgb = Gordic.Adm.Utils.HexToNumber(value.barva)
            //                if (rgb)
            //                    return { red: rgb.r, green: rgb.g, blue: rgb.b, hexa: value.barva };
            //            }
            //        },
            //        collect: (value) => {
            //            if (value)
            //                if (value.hexa) {
            //                    value.barva = value.hexa
            //                    return value;
            //                } else
            //                    return null
            //            else
            //                return null
            //        }
            //    }
            //})
            //this.MakeField("barva");
            //this.MakeSelectField("uroven_vla", Gordic.Prefabs.Select.gincuvl(), { model: "model.uroven_vla=value.uroven_vla" });
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        createHodnotaVlastnostSubTask(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-obsah-vlastnosti",
                    title: "jres:33000457",
                    opened: true,
                    locked: true,
                    group: { id: "_tab-obsah-vlastnosti" }
                },
                //contentParams: GContent.createInitializer("Gordic.Adm.WebControls.SeznamAdmVlastnostHodnota", { Id: "SeznamAdmVlastnostHodnota", ixs_vla: this.data.ixs_vla })
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmVlastnostHodnota",
                    serverParams: {
                        Id: "SeznamAdmVlastnostHodnota",
                        ixs_vla: this.data.ixs_vla,
                        tabOpen: true
                    }
                }
            }
        }

        createHodnotaVlastnostGroup(): IGTabGroupOptions {
            return { id: "_tab-obsah-vlastnosti", caption: "jres:33000457" }
        }

        createNadrizeneSubTask(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-nadrizene",
                    title: "jres:33000563", //RC 33000563 : Nad��zen� struktury a vlastnosti
                    opened: true,
                    locked: true,
                    group: { id: "_tab-nadrizene" },
                    open: () => {
                        this.getNadrizene();
                    }
                }, 
                init: (tab) => {
                    this.createGridNadrizene(tab);
                }
            }
        }

        createNadrizeneGroup(): IGTabGroupOptions {
            return { id: "_tab-nadrizene", caption: "jres:33000563" }
        }

        private createGridNadrizene(tab: JQuery<HTMLElement>) {
            this.gridNadrizene = $("<div>").appendTo(tab).gautofit({ resizersOnTab: false }).ggrid({
                columns: this.createGridFormatNadrizene(),
                defaultAction: this.cnt.actions.actOpenDetailStrukturaProfil,
                selection: (ev, ctx) => {
                    this.cnt.actions.actOpenDetailStrukturaProfil?.update({ enabled: ctx.count == 1 })
                }
            })
        }

        private createGridFormatNadrizene() {
            return new Gordic.Data.GridFormat()
                .addIconColumn({
                    name: "aktivita",
                    caption: "jres:33000559", //RC 33000559 : Aktivita vazby
                    iconTemplate: (row) => {
                        return Gordic.Adm.WebControls.GAdmGridFunctions.createAktivitaCaptionIcon(row.aktivita);
                    }
                })
                .addTextColumn({
                    name: "typ",
                    caption: "jres:33000553",
                    cellTemplate: (row) => {
                        if (row.typ == 20)
                            return "jres:29932128";
                        else if (row.typ == 10)
                            return "jres:29931622";
                        else
                            return "jres:33000410"
                    }
                })
                .addTextColumn({
                    name: "ixs_txt",
                    caption: "jres:32131029",
                })
        }

        private getNadrizene() {
            if (this.gridNadrizene != undefined && this.gridNadrizene != null) {
                if (this.data.ixs_vla) {
                    this.cnt.isl.AdmVlastnost.listNadrizene({ ixs_vla: this.data.ixs_vla }).getData().done((obj) => {
                        this.gridNadrizene.ggrid("setData", obj);
                    })
                }
            }
        }

        private createValidatorKod(): Gordic.Validators.Base {
            return new Gordic.Validators.Base({
                stopping: true,
                message: "jres:33000480".format("., _"), //RC 33000480 : Zadan� �et�zec obsahuje nepovolen� znaky.
                validate: (value, source) => {
                    if (value) {
                        if (value.toString().includes("_") || value.toString().includes("."))
                            return false;
                        if (value.toString() == "0")
                            return false;
                        return true;
                    }
                    return false;
                }
            });
        }

        private createValidatorKodForm(): Gordic.Validators.Base {
            return new Gordic.Validators.Base({
                stopping: true,
                message: "jres:33000480".format("."),
                validate: (value, source) => {
                    if (value) {
                        if (value.toString().includes("."))
                            return false;
                    }
                    return true;
                }
            });
        }

        private openSeznamAdmVlastnostObjekt2() {
            this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostTypObjektu"], {
                Id: "SeznamAdmVlastnostTypObjektu",
                typ_vps: 20,
                ixs: this.data.ixs_vla
            })
        }

        private openSeznamAdmVlastnostTypDokumentu() {
            this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostTypDokumentu"], {
                Id: "SeznamAdmVlastnostTypDokumentu",
                typ_vps: 20,
                ixs: this.data.ixs_vla
            })
        }

        private openDetailStrukturaProfil() {
            var activeRow = this.gridNadrizene.ggrid("activeRow");
            if (activeRow) {
                if (activeRow.typ == 0) {
                    $.content().navigate(
                        ["Gordic.Adm.WebControls.DetailAdmProfilVlastnosti", {}],
                        {
                            ID: "DetailAdmProfilVlastnosti",
                            newRecord: false,
                            ixs_pro: activeRow.ixs
                        }
                    )
                } else {
                    $.content().navigate(
                        ["Gordic.Adm.WebControls.DetailAdmStrukturaVlastnosti", {}],
                        {
                            ID: "DetailAdmStrukturaVlastnosti",
                            newRecord: false,
                            ixs_stv: activeRow.ixs
                        }
                    )
                }
            }
        }

        private openDefaultValueVlastnost() {
            this.cnt.dialogs.showModalWindow([Gordic.Adm.WebControls.DialogAdmVlastnostDefaultValue, { data: this.data }], null, "jres:33000475", 600, 300).on('close', (o, result) => {
                if (result) {
                    if (result == true)
                        this.reloadDataBase();
                }
            })
        }
    }
}